module.exports = __webpack_public_path__ + "eca2c26759a009a4a9361151efe99e74.svg";